export default __webpack_public_path__ + "static/media/image-board-study-now-n-m@3x.c3350551.webp";